import React from "react";
import { useTranslation } from "react-i18next";
import { useTelemetry } from "../../context/TelemetryContext";
import ModeIndicator from "../../components/shared/ModeIndicator";
import DemoDataNotice from "../../components/shared/DemoDataNotice";
import LanguageToggle from "../../components/shared/LanguageToggle";
import SubPageNav from "../../components/shared/SubPageNav";

function AIOperations() {
const { t } = useTranslation();

const telemetry = useTelemetry();

return (

<div
style={{
padding: "20px",
color: "white"
}}
>

<div
style={{
textAlign:"center",
marginBottom:"30px"
}}
>

<div style={{position:"relative",textAlign:"center",marginBottom:"20px"}}><h1>{t("aiOperations.title")}</h1><div style={{position:"absolute",top:0,right:0,display:"flex",alignItems:"flex-start",gap:"12px"}}><LanguageToggle /><ModeIndicator /></div></div>

<p
style={{
color:"#94a3b8",
marginTop:"10px"
}}
>
{t("aiOperations.subtitle")}
</p>

</div>

<div
style={{
display: "grid",
gridTemplateColumns: "1fr 1fr",
gap: "20px"
}}
>
<div
style={{
background:"#111827",
padding:"20px",
borderRadius:"14px",
border:"1px solid #1e293b",
minHeight:"180px"
}}
>

<h3>{t("aiOperations.status.title")}</h3>

<div
style={{
fontSize:"42px",
fontWeight:"bold",
marginTop:"15px",
color:
telemetry.overallRisk === "CRITICAL"
? "#ef4444"
: telemetry.overallRisk === "WARNING"
? "#f59e0b"
: "#22c55e"
}}
>
{t(`commandCenter.risk.${telemetry.overallRisk}`, telemetry.overallRisk)}
</div>

<p
style={{
marginTop:"15px",
color:"#94a3b8"
}}
>
{t("aiOperations.status.autonomousDecisionProcessing")}
</p>

<p
style={{
marginTop:"15px"
}}
>
{t("aiOperations.status.aiConfidence")}: {telemetry.aiConfidence}%
</p>

</div>


<div
style={{
background:"#111827",
padding:"20px",
borderRadius:"14px",
border:"1px solid #1e293b",
minHeight:"180px"
}}
>

<h3>{t("aiOperations.decisionCenter.title")}</h3>

<div
style={{
marginTop:"20px",
color:"#cbd5e1"
}}
>

<p>
{t("aiOperations.decisionCenter.currentRisk")}: {t(`commandCenter.risk.${telemetry.overallRisk}`, telemetry.overallRisk)}
</p>

<p style={{marginTop:"12px"}}>
{
telemetry.overallRisk === "CRITICAL"
? t("aiOperations.decisionCenter.emergencyWorkflowActivated")
: telemetry.overallRisk === "WARNING"
? t("aiOperations.decisionCenter.enhancedMonitoringActive")
: t("aiOperations.decisionCenter.normalOperations")
}
</p>

<p
style={{
marginTop:"12px",
color:"#22c55e"
}}
>
{t("aiOperations.decisionCenter.humanOversightActive")}
</p>

</div>

</div>


<div
style={{
gridColumn:"1 / span 2",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"25px"
}}
>
{t("aiOperations.intelligenceCenter.title")}
</h3>
<p style={{color:"#475569",fontSize:"0.75rem",fontStyle:"italic",textAlign:"center"}}>{t("aiOperations.intelligenceCenter.operationalCountsNote")}</p>

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(4,1fr)",
textAlign:"center"
}}
>

<div>
<h4>{t("aiOperations.intelligenceCenter.aiConfidence")}</h4>
<div style={{color:"#22c55e",fontSize:"32px",fontWeight:"bold"}}>
{telemetry.aiConfidence}%
</div>
</div>

<div>
<h4>{t("aiOperations.intelligenceCenter.activeAgents")}</h4>
<div style={{color:"#38bdf8",fontSize:"32px",fontWeight:"bold"}}>
12
</div>
</div>

<div>
<h4>{t("aiOperations.intelligenceCenter.decisionsProcessed")}</h4>
<div style={{color:"#f59e0b",fontSize:"32px",fontWeight:"bold"}}>
11847
</div>
<DemoDataNotice textKey="common.demoDataNotice.simulatedCount" />
</div>
<div>
<h4>{t("aiOperations.intelligenceCenter.learningAccuracy")}</h4>
<div style={{color:"#22c55e",fontSize:"32px",fontWeight:"bold"}}>
97%
</div>
<DemoDataNotice textKey="common.demoDataNotice.illustrativeFigure" />
</div>

</div>

<hr
style={{
margin:"25px 0",
borderColor:"#1e293b"
}}
/>

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(4,1fr)",
textAlign:"center"
}}
>

<div>
<h4>{t("aiOperations.intelligenceCenter.explainability")}</h4>
<div style={{color:"#22c55e"}}>{t("commandCenter.status.verified")}</div>
</div>

<div>
<h4>{t("aiOperations.intelligenceCenter.memoryAccess")}</h4>
<div style={{color:"#22c55e"}}>{t("commandCenter.status.active")}</div>
</div>

<div>
<h4>{t("aiOperations.intelligenceCenter.traceability")}</h4>
<div style={{color:"#22c55e"}}>{t("commandCenter.status.enabled")}</div>
</div>

<div>
<h4>{t("aiOperations.intelligenceCenter.humanOversight")}</h4>
<div style={{color:"#22c55e"}}>{t("commandCenter.status.active")}</div>
</div>

</div>

<h4
style={{
textAlign:"center",
marginBottom:"15px"
}}
>
{t("aiOperations.intelligenceCenter.activityFeedTitle")}
</h4>

<div
style={{
display:"flex",
justifyContent:"center",
flexWrap:"wrap",
gap:"15px",
marginTop:"15px",
color:"#cbd5e1",
fontSize:"16px"
}}
>

<span>{t("aiOperations.intelligenceCenter.feed1")}</span>

<span>{t("aiOperations.intelligenceCenter.feed2")}</span>

<span>{t("aiOperations.intelligenceCenter.feed3")}</span>

<span>{t("aiOperations.intelligenceCenter.feed4")}</span>

<span>{t("aiOperations.intelligenceCenter.feed5")}</span>

</div>
</div>

{/* Learning Engine */}

<div
style={{
background: "#111827",
padding: "20px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{t("aiOperations.learningEngine.title")}</h3>

<h2
style={{
marginTop: "15px",
color: "#22c55e",
fontSize: "40px"
}}
>
4312
</h2>

<p style={{ color: "#94a3b8" }}>
{t("aiOperations.learningEngine.patternsLearned")}
</p>

<div
style={{
marginTop: "15px",
color: "#cbd5e1"
}}
>
{t("aiOperations.learningEngine.lastSimilarMatch", { value: "81%" })}
</div>

</div>

{/* AI Memory */}

<div
style={{
background: "#111827",
padding: "20px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{t("aiOperations.aiMemory.title")}</h3>

<h2
style={{
marginTop: "15px",
color: "#38bdf8",
fontSize: "40px"
}}
>
3156
</h2>

<p style={{ color: "#94a3b8" }}>
{t("aiOperations.aiMemory.storedEvents")}
</p>
<DemoDataNotice textKey="common.demoDataNotice.simulatedCount" />

<div
style={{
marginTop: "15px",
color: "#cbd5e1"
}}
>
{t("aiOperations.aiMemory.similarIncidents", { count: 148 })}
</div>

<div
style={{
marginTop: "10px",
color: "#94a3b8"
}}
>
{t("aiOperations.aiMemory.lastRetrieval", { value: t("aiOperations.aiMemory.lastRetrievalValue") })}
</div>

</div>

</div>

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("aiOperations.summary.title")}
</h3>

<p
style={{
textAlign:"center",
color:"#94a3b8",
lineHeight:"1.8"
}}
>
{t("aiOperations.summary.part1")}{" "}
<strong>{t(`commandCenter.risk.${telemetry.overallRisk}`, telemetry.overallRisk)}</strong>{" "}
{t("aiOperations.summary.part2")}{" "}
<strong>{telemetry.aiConfidence}%</strong>.
{" "}{t("aiOperations.summary.part3")}
</p>
</div>

<SubPageNav current="aiOperations" />

</div>

);

}

export default AIOperations;